// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachMenu_root__cYv6W","menu":"AttachMenu_menu__rLI00","item":"AttachMenu_item__5F2A7","itemIcon":"AttachMenu_itemIcon__ociob"};